import React from 'react';
import Box from '@mui/material/Box';
import BillsTable from '../components/LegislationComponents/BillsTable';

const BillsPage = () => {
  return (
    <Box className="bills-page" sx={{ minHeight: '100vh', bgcolor: '#f8fafc' }}>
      <BillsTable />
    </Box>
  );
};

export default BillsPage;
